import { render, staticRenderFns } from "./PDFPage.vue?vue&type=template&id=b9d26f4c&scoped=true"
import script from "./PDFPage.vue?vue&type=script&lang=js"
export * from "./PDFPage.vue?vue&type=script&lang=js"
import style0 from "./PDFPage.vue?vue&type=style&index=0&id=b9d26f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d26f4c",
  null
  
)

export default component.exports